import { Search, ShoppingCart } from "@mui/icons-material";
import { Badge} from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile } from "../responsive";

const Container = styled.div`
  height: 60px;
  ${mobile({ height: "50px" })}
`;
const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mobile({ padding: "10px 0" })}
`;
const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;
const Language = styled.span`
  font-size: 14px;
  cursor: pointer;
  ${mobile({ display: "none" })}
`;
const SearchContainer = styled.div`
  border: 0.5px solid lightgrey;
  display: flex;
  align-items: center;
  margin-left: 25px;
  padding: 5px;
  ${mobile({ marginLeft: "5px" })}
`;
const Input = styled.input`
  border: none;
  ${mobile({ width: "50px" })}
`;
const Center = styled.div`
  flex: 1;
  text-align: center;
`;
const Logo = styled.h1`
  font-weight: bolder;
  ${mobile({ fontsize: "1rem", textAlign: "left" })}
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${mobile({ flex: "2", justifyContent: "left" })}
`;
const MenuItem = styled.div`
  font-size: 15px;
  cursor: pointer;
  margin-left: 25px;
  ${mobile({ fontSize: "12px", marginLeft: "10px" })}
`;



const Navbar = () => {


  return (
    <Container>
      <Wrapper>
        <Left>
          {" "}
          <Language> EN </Language>
          <SearchContainer>
            <Input placeholder="search" />
            <Search style={{ color: "gray", fontSize: 16 }} />
          </SearchContainer>
        </Left>
        <Link to="/" className="link">
        <Center >
          {" "}
          <Logo>GAMA.</Logo>{" "}
          
        </Center>
        </Link>
        <Right>
        <Link to="/register" className="link">

          <MenuItem>REGISTER </MenuItem>
          </Link>
          <Link to="/login" className="link">

          <MenuItem>SIGN IN</MenuItem>
          </Link>
          <Link to="/cart" className="link">
          <MenuItem>
            <Badge badgeContent={4} color="primary">
              <ShoppingCart />
              
            </Badge>
          </MenuItem>
          </Link>
        </Right>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
